/* eslint-disable react-hooks/exhaustive-deps */
import ArticlePlaceholder from 'components/ui/article-placeholder';
import { AuthContext } from 'context/AuthContext';
import { useContext, useEffect, useState } from 'react';
import { RiArrowLeftSLine } from 'react-icons/ri';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { getAddress, getCatalog } from 'services/store.service';
import BoxStore from './BoxStore';
import { getChallengeUser } from 'services/challenges.service';
import Modal from './modal';
import { FaEdit } from 'react-icons/fa';
import { differenceInDays } from 'date-fns';
import { getServerTime } from 'services/dashboard.service';

import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function Store() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any[]>();
  const [totalRede, setTotalRede] = useState(0);
  const [totalCompletedRede, setTotalCompletedRede] = useState(0);
  const [disabled, setDisabled] = useState<string | boolean>(false);
  const [bought, setBought] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [time, setTime] = useState(0);
  const [address, setAddress] = useState<any>();
  const [date, setDate] = useState<any>();

  useEffect(() => {
    if (!user) return;
    setLoading(true);
    async function loadData() {
      const data = await getCatalog();
      const _data = await getChallengeUser();
      const address = await getAddress();

      const _address = address?.[0];
      setAddress(_address);

      const _totalRede = _data.filter((item: any) => {
        if (item?.extra?.perfil === 'rede') return true;

        return false;
      });
      const completed = _totalRede.filter((item: any) => item.completed).length;

      setData(data?.items);
      setDate(data.extra);
      setTotalCompletedRede(completed);
      setTotalRede(_totalRede.length);
      setLoading(false);

      const _bought = data?.items?.filter((item: any) => item?.purchased > 0)?.length > 0;

      const _disabled = _bought ? 'purchased' : completed === 0 || completed < _totalRede.length ? 'disabled' : false;

      setDisabled(_disabled);
      setBought(_bought);
    }

    loadData();
  }, [user]);

  useEffect(() => {
    async function loadTime() {
      const res = await getServerTime();
      setTime(res);
    }

    if (!!user) {
      loadTime();
    }
  }, [user]);

  function canEdit(item: any) {
    if (item?.attributes?.status !== 'OK') {
      return false;
    }

    if (!!item && !!time) {
      const differenceTime = differenceInDays(new Date(time), new Date(item.time));

      return differenceTime <= 10;
    }

    return false;
  }

  if (!user) return null;

  return (
    <>
      <div className="mx-auto container p-3 lg:p-10 overflow-hidden">
        <>
          <div className=" mb-3 lg:mb-10">
            <div className="md:flex justify-between items-center">
              <div className="flex flex-ro items-center space-x-3 lg:space-x-1">
                <div>
                  <Link to="../">
                    <button className="rounded-full bg-purple flex justify-center items-center p-1">
                      <RiArrowLeftSLine size={28} className="text-white" />
                    </button>
                  </Link>
                </div>

                <h1 className="text-lg lg:text-3xl  py-1 px-6 rounded-full">Catálogo de experiências</h1>
              </div>
            </div>

            <div className="lg:flex border-electric-blue border-2 rounded-2xl bg-oxford-blue py-5 px-7 mt-10">
              <div className="w-full border-electric-blue  -my-5 py-5 pr-0 lg:pr-[70px] pl-3">
                <p className="text-lg">Realize todos os desafios e resgate um presente de lançamento.</p>

                {date?.start && date?.end && (
                  <p>{`Período de abertura do Catálogo de Experiência: ${format(new Date(date.start), "dd 'de' MMMM", {
                    locale: ptBR,
                  })} até ${format(new Date(date.end), "dd 'de' MMMM 'de' yyyy", { locale: ptBR })}`}</p>
                )}

                {address?.name && (
                  <p>
                    Nome: {address?.name}.<br />
                    Endereço de entrega: {address?.address}, {address?.number}, {address?.complement}.<br />
                    Cidade: {address?.city}.<br />
                    Estado: {address?.state}.<br />
                    CEP: {address?.cep?.slice(0, 5) + '-' + address?.cep?.slice(5)}
                    <br />
                    Email: {address?.email}
                    <br />
                    Telefone: {address?.phone}
                  </p>
                )}

                {/* {bought && (
                  <button
                    onClick={() => setShowModal(true)}
                    className="flex space-x-1 items-center text-electric-blue bg-transparent border-none p-0 text-md cursor-pointer"
                  >
                    <FaEdit /> <p>Editar endereço</p>
                  </button>
                )} */}
              </div>
            </div>

            <div className="mt-5 content-store grid lg:grid-cols-4 gap-5">
              {loading ? (
                <>
                  <ArticlePlaceholder />
                  <ArticlePlaceholder />
                  <ArticlePlaceholder />
                  <ArticlePlaceholder />
                </>
              ) : (
                data?.map((e: any, i) => (
                  <BoxStore
                    key={`box_${e._id}`}
                    disabled={disabled}
                    data={e}
                    total={{ completed: totalCompletedRede, total: totalRede }}
                    address={address}
                    onPurchase={() => setShowModal(true)}
                  />
                ))
              )}
            </div>
          </div>
        </>
        
      </div>
    </>
  );
}
